import { Component, Input, OnInit } from "@angular/core";
import { SortMeta, SortEvent } from "primeng/api";
import { ObjectUtils } from "../../../student/student-demographics/shared/ObjectUtils";

@Component({
	selector: "caass-staff-current-reminders-table",
	templateUrl: "./staff-current-reminders-table.component.html",
	styleUrls: ["./staff-current-reminders-table.component.css"],
})
export class StaffCurrentRemindersTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	multiSortMeta: SortMeta[] = [];

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedStationReminderAlert: any;
	@Input() lstStationReminderAlert: any = [];

	//Filter lists
	lstAlertTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'Message', header: 'Message' },
		// { field: 'SoundFile', header: 'Sound' },
		// { field: 'AlertTypeDesc', header: 'Occurs' },
		// { field: 'RangeDesc', header: 'Next Occurrence' },
	];

	ModeCols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "EntryMode", header: "Entry Mode" },
		{ field: "ExitMode", header: "Exit Mode" },
		{ field: "MealMode", header: "Meal Mode" },
		{ field: "AccessMode", header: "Access Mode" },
		{ field: "TimeStampMode", header: "Time Stamp Mode" },
		{ field: "EventEntryMode", header: "Event Entry Mode" },
		{ field: "EventExitMode", header: "Event Exit Mode" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		this.lstAlertTypeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.AlertTypeDesc))).sort();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedStationReminderAlert = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStationReminderAlert = null;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	//
	// Sort by order then by column
	//
	OrderSort(event: SortEvent) {
		// console.log("Custom Sort");
		// console.log(event);

		//event.data = Data to sort
		//event.mode = 'single' or 'multiple' sort mode
		//event.field = Sort field in single sort
		//event.order = Sort order in single sort
		//event.multiSortMeta = SortMeta array in multiple sort

		var sortArr: SortMeta[] = [];

		//   { field: "ZOrder", order: -1},
		// ];

		sortArr = [...sortArr, ...event.multiSortMeta];

		var ZOrderFound = false;

		for (var z = 0; z < sortArr.length; z++) {
			var next = sortArr[z];

			if (next.field == "ZOrder") {
				ZOrderFound = true;
			}
		}

		if (!ZOrderFound) {
			var ZOrderSort: SortMeta = {
				field: "ZOrder",
				order: 1,
			};

			sortArr = [...sortArr, ZOrderSort];
		}

		// console.log("Sort Arr");
		// console.log(sortArr);

		event.data.sort((data1, data2) => {
			return this.multisortField(data1, data2, sortArr, 0);
		});

		// console.log("New Data");
		// console.log(event.data);
	}

	multisortField(data1, data2, multiSortMeta, index) {
		const value1 = ObjectUtils.resolveFieldData(data1, multiSortMeta[index].field);
		const value2 = ObjectUtils.resolveFieldData(data2, multiSortMeta[index].field);
		if (ObjectUtils.compare(value1, value2, "") === 0) {
			return multiSortMeta.length - 1 > index ? this.multisortField(data1, data2, multiSortMeta, index + 1) : 0;
		}
		return this.compareValuesOnSort(value1, value2, multiSortMeta[index].order);
	}

	compareValuesOnSort(value1, value2, order) {
		return ObjectUtils.sort(value1, value2, order, "", 1);
	}

	////////////////////////////////////////////
}
